
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/system/shadows",
      function () {
        return require("private-next-pages/system/shadows.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/system/shadows"])
      });
    }
  